<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Lista letti</span>
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovoLetto" class="mb-2"> <font-awesome-icon icon="plus"> </font-awesome-icon> Aggiungi</b-button>

                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table sa-card-border">
                        <template #cell(index)="row">
                            <span>{{ row.index + 1 }}</span>
                        </template>
                        <template #cell(actions)="{ item }">
                            <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-secondary" @click="onClickVisualizzaLetto(item)">
                                <i class="bi bi-eye"></i>
                            </b-button>
                            <b-button size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onClickModificaLetto(item.id)">
                                <i class="fas fa-pen"></i>
                            </b-button>
                            <b-button size="sm" class="mr-1 ml-1 no-text" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onDeleteLetto(item)">
                                <b-icon icon="trash"></b-icon>
                            </b-button>
                        </template>
                    </b-table>
                </div>
            </div>

            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Record Totali: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>

            <rsa-configurazione-posti-letto-letti-edit-component ref="cmpRsaConfigurazionePostiLettoLettiEdit" @afterCloseModal="onAfterCloseModal" @saveResponse="loadData" />
        </div>
    </div>
</template>

<script>
import axios from "axios";
import RsaConfigurazionePostiLettoLettiEditComponent from "./RsaConfigurazionePostiLettoLettiEditComponent.vue";
export default {
    components: { RsaConfigurazionePostiLettoLettiEditComponent },
    props: {
        idPiano: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsapostilettoletti",
            showModalLoading: false,
            btnNuovaStanzaHidden: false,
            filtro: {},
            items: [],
            idStanza: "",
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                    //sortable: true,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Nome",
                    key: "nome",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Tipo letto",
                    key: "tipoLetto",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                    sortable: true,
                    thStyle: "width: 16rem",
                },
                {
                    label: "Note",
                    key: "note",
                    sortable: true,
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
        };
    },
    mounted() {
        // let me = this;
        // me.loadData();
    },

    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },

    methods: {
        init(id) {
            let me = this;
            me.idStanza = id;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtro"]) {
                me.filtro = JSON.parse(sessionStorage["filtro"]);
            }
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtro.page = me.currentPage;
            me.filtro.forPage = me.perPage;

            if (me.idStanza) {
                me.filtro.idStanza = me.idStanza;
            }
            axios
                .get(link, { params: me.filtro })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onDeleteLetto(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Letto",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteLetto(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteLetto(id) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
            axios
                .delete(link)
                .then((response) => {
                    me.showModalLoading = false;
                    me.$emit("onDelete", response);
                    me.$bvToast.toast("Eliminazione avvenuta con successo", {
                        title: "Successo",
                        variant: "success",
                        solid: true,
                    });
                    me.loadData();
                })
                .catch((e) => {
                    console.log(e);
                    me.showModalLoading = false;
                    me.$bvToast.toast("Errore durante l'eliminazione", {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },

        onDelete() {
            this.loadData();
        },
        /* onShowConfigurazioneLetto() {
            let me = this;
            me.$refs.cmpRsaConfigurazionePostiLettoLettiEdit.loadData();
        }, */
        onAfterCloseModal() {
            let me = this;
            me.loadData();
        },
        onClickVisualizzaLetto(item) {
            let me = this;
            me.$router.push("/rsagestionecamere/view/" + item.id);
        },
        onClickNuovoLetto() {
            let me = this;
            me.$refs.cmpRsaConfigurazionePostiLettoLettiEdit.show(this.idStanza);
            // console.log("idStanza: ", this.idStanza);
        },
        onClickModificaLetto(id) {
            let me = this;
            me.$refs.cmpRsaConfigurazionePostiLettoLettiEdit.showConfigurazioneLettoEdit(id);
        },
    },
};
</script>

<style></style>
